import * as Styled from './notification-badge.styles';
const { variants } = Styled;
//# sourceMappingURL=notification-badge.types.js.map